import React from "react";
import lang from '../../i18/lang';
import Map from "../map/Map";
import './Footer.scss';


class Footer extends React.Component {

    static mapProps = {
        center: {
            lat: 59.95,
            lng: 30.33,
        },
        zoom: 11
    };

    render() {
        return (
            <div className="footer-wrapper">
         {/*       <div className="footer-nav-wrapper">
                    <div className="nav-section">
                        <h4>{lang.srb.section.footer.o_nama}</h4>
                        <p className="color-black">{lang.srb.section.footer.kako_radimo}</p>
                        <p className="color-black">{lang.srb.section.footer.ko_su_nam_kupci}</p>
                        <p className="color-black">{lang.srb.section.footer.zasto_bas_mi}</p>
                    </div>
                    <div className="nav-section">
                        <h4>{lang.srb.section.footer.igraonice}</h4>
                        <p className="color-black">{lang.srb.section.footer.elementi}</p>
                        <p className="color-black">{lang.srb.section.footer.usluge}</p>
                        <p className="color-black">{lang.srb.section.footer.galerija}</p>
                    </div>
                    <div className="nav-section">
                        <h4>{lang.srb.section.footer.bam_igraonice}</h4>
                        <p className="color-black">{lang.srb.section.footer.nasa_misija}</p>
                    </div>
                    <div className="nav-section">
                        <h4>{lang.srb.section.footer.kontakt}</h4>
                    </div>
                </div>*/}
                <div className="footer-map-wrapper">
                    <div className="map-content">
                        <div>
                            <h6>{lang.srb.section.footer.nasa_lokacija_title}</h6>
                            <p>{lang.srb.section.footer.nasa_lokacija_adresa}</p>
                            <p>{lang.srb.section.footer.nasa_lokacija_grad}</p>
                        </div>
                        <div className="separator"></div>
                        <div className="flex-space-between">
                            <div>
                                <h6>{lang.srb.section.footer.telefon}</h6>
                                <p><a href={`tel:${lang.srb.section.footer.telefon_1}`}>{lang.srb.section.footer.telefon_1}</a></p>
                                <p><a href={`tel:${lang.srb.section.footer.telefon_2}`}>{lang.srb.section.footer.telefon_2}</a></p>
                            </div>
                            <div>
                                <h6>{lang.srb.section.footer.radno_vreme}</h6>
                                <p>{lang.srb.section.footer.radno_vreme_radni_dani}</p>
                                <p>{lang.srb.section.footer.radno_breme_vikend}</p>
                            </div>
                        </div>
                    </div>
                    <div className="triangle"></div>
                    <div className="map">
                       {/* <Map/>*/}

                        <div className="mapouter">
                            <div className="gmap_canvas">
                                <iframe width="1080" height="320" id="gmap_canvas"
                                        src="https://maps.google.com/maps?q=belgrade&t=&z=9&ie=UTF8&iwloc=&output=embed"
                                        frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe>
                                <a href="https://www.enable-javascript.net/blog/divi-discount/">wiecej informacji o
                                    divi</a></div>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright">
                    <p className="color-black">{lang.srb.section.footer.copyright}</p>
                </div>
                <div>

                </div>
            </div>
        )
    }
}

export default Footer;